<template>
  <div class="bg-w ">

    <div class="pl-20 pt-20 pr-20">
      <div class="flex a-center flex-wrap">
        <div class="flex a-center mr-20 mb-20">
          <div>下单日期：</div>
          <div><a-range-picker v-model="time" class="w-200" /></div>
        </div>
        <div class="flex a-center mr-20 mb-20">
          <div>员工（子账号）：</div>
          <div>
            <a-select v-model="params.originCustomerId" class="w-160" placeholder="请选择员工">
              <a-select-option :key="-1" :value="''">全部</a-select-option>
              <a-select-option v-for="(i,index) in staffList" :key="index" :value="i.userid">
                {{ i.staffname }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="flex a-center mr-20 mb-20">
          <div>快递公司：</div>
          <div class="">
            <a-select v-model="params.shipperCode" class="w-160" placeholder="请选择快递公司">
              <a-select-option :key="-1" :value="''">全部</a-select-option>
              <a-select-option v-for="(i,index) in companys" :key="index" :value="i.shipperCode">{{ i.shipperName }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="flex a-center mr-20 mb-20">
          <a-button type="primary" @click="getList(true)">查 询</a-button>
        </div>
      </div>
    </div>
    <div class="pd-20">
      <a-table :columns="columns" :row-key="getKey" :data-source="list" :pagination="pagination" @change="handleTableChange">
        <div slot="time" slot-scope="row">
          {{ row.createTimeStart }}~{{ row.createTimeEnd }}
        </div>
        <div slot="staff" slot-scope="row" class="text-over">
          {{ row.staffName }}（{{ row.staffAccount }}）
        </div>
        <div slot="action" slot-scope="row">
          <span class="f-c-blue pointer" @click="toSearch(row)">寄件明细</span>
        </div>
      </a-table>
    </div>

  </div>
</template>
<script>
const columns = [
  { title: '周期', key: 'time', scopedSlots: { customRender: 'time' }},
  { title: '员工（子账号）', key: 'staff', scopedSlots: { customRender: 'staff' }},
  { title: '部门', dataIndex: 'departmentName', key: 'departmentName' },
  { title: '订单数', key: 'totalCount', dataIndex: 'totalCount' },
  { title: '运费金额（元）', dataIndex: 'fee', key: 'fee' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }}
]

export default {
  components: {
  },

  data() {
    return {
      visible: false,
      visible1: false,
      addressType: {
        1: '寄件',
        2: '收件'
      },
      columns,
      params: {
        'beginDate': '',
        'originCustomerId': '',
        'endDate': '',
        'shipperCode': ''
      },
      list: [],
      loading: false,
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      },
      cInfo: null,
      time: null,
      companys: [],
      staffList: []
    }
  },
  watch: {
    time(n) {
      if (n) {
        this.params.beginDate = n[0].format('YYYY-MM-DD')
        this.params.endDate = n[1].format('YYYY-MM-DD')
      } else {
        this.params.beginDate = ''
        this.params.endDate = ''
      }
    }
  },
  async created() {
    const res = await this.$http(this.$api.logisticsGetList)
    this.companys = res || []
    const staffList = await this.$http(this.$api.staffGetStaffList, {})
    this.staffList = staffList || []
    this.getList()
  },
  methods: {
    toSearch(row) {
      sessionStorage.setItem('searchParams', JSON.stringify(row))
      this.$router.push('/main/search?tab=2')
    },
    getKey(row) {
      return JSON.stringify(row)
    },
    async handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getList()
    },
    async getList(isReset) {
      if (isReset) {
        this.pagination.current = 1
      }
      this.params.pageIndex = this.pagination.current
      this.params.pageSize = this.pagination.pageSize
      const res = await this.$http(this.$api.orderGetSenderPageList, { ...this.params })
      if (res) {
        this.list = res.list || []
        this.pagination.current = res.pageIndex
        this.pagination.pageSize = res.pageSize
        this.pagination.total = res.totalSize
      }
    }
  }
}
</script>
